const DEFAULT_WIDTH = 500
const DEFAULT_HEIGHT = 300

export default class ShareButton {
  constructor(el) {
    this.button = el
    this.button.addEventListener('click', e => {
      e.preventDefault()
      this._openShareWindow()
    })
  }

  _openShareWindow() {
    const url = this.button.getAttribute('href') || ''
    window.open(url, '', this._getWindowOptions())
  }

  _getWindowOptions() {
    const width = this.button.dataset.width || DEFAULT_WIDTH
    const height = this.button.dataset.height || DEFAULT_HEIGHT
    return `width=${width},height=${height},toolbar=no,menubar=no,location=no`
  }

  static initialize() {
    Array.from(document.querySelectorAll('a[role=share-button]')).forEach(el => {
      if (!el.dataset.shareButton) {
        if (el.getAttribute('target') === '_blank') {
          el.dataset.shareButton = new ShareButton(el)
        }
      }
    })
  }
}
